import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getDashboardCountAPI = () => {
  return Http.get(ApiRoutes.dashboard);
};
export const getBookingAPI = (data:any) => {
  return Http.get(`dashboard/booking?filter=${data}`);
};
export const getCustomerAPI = (data:any) => {
  return Http.get(`dashboard/customer?filter=${data}`);
};
export const getChefsDashboardCountAPI = (data:any) => {
  return Http.get(`dashboard/chef?filter=${data}`);
};